import React, { useState, useEffect, useRef } from "react";
import {
  Notifications,
  Place,
  Phone,
  AirlineSeatIndividualSuite,
} from "@mui/icons-material";
import FlatList from "flatlist-react";
import { ToastContainer, toast } from "react-toastify";
import "react-activity/dist/library.css";
import Modal from "react-modal";
import apilink from "../apiURL/baseUrls";
import axios from "axios";
import { Squares } from "react-activity";
import { ShoppingCart } from "@mui/icons-material";
import moment from "moment";
import { addRecord, getAllRecords, PRODUCT_STORE, RATE_STORE, getLastSalesId, SALES_STORE } from "../dbControllers/dbController";

const Home = () => {
  const [shopId, setShopId] = useState("");
  const [shopName, setShopName] = useState("");
  const [cashierId, setCashierId] = useState("");
  const [cashierName, setCashierName] = useState("");

  const [products, setProducts] = useState([]);
  const [cart, setCart] = useState([]);
  const [cartTotal, setCartTotal] = useState(0.00);

  const [searchTerm, setsearchTerm] = useState("");
  const [quantities, setQuantities] = useState({});
  const [siunits, setSiunits] = useState({});

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [payIsOpen, setPayIsOpen] = useState(false);

  const [currencies, setCurrencies] = React.useState([]);
  const [receiptnumber, setReceiptnumber] = React.useState(0);

  const removeOnCart = async (id) => {
    console.log("Remove: " + id);
    let addedItem = products.find((obj) => obj.productid == id);
    let onCart = cart.find((obj) => obj.productid == id);

    let objIndex = null;
    let baseUnit = "Singles";

    if (onCart != null) {
      let tempArr = [...cart];
      objIndex = tempArr.findIndex((obj) => obj.productid == id);
      tempArr = [...tempArr.filter((item) => item.productid != id)];
      setCart([...tempArr]);
      let netTotal = tempArr.reduce((acc, current) => acc + parseFloat(current.total), 0);
      netTotal = netTotal.toFixed(2);
      setCartTotal(netTotal);
    }
  }

  const handleItemPress = async (id) => {
    let qty = quantities[id] || '1';
    const unit = siunits[id] || 'Singles';
    console.log("QTY", qty);
    console.log("UNIT", unit);

    let addedItem = products.find((obj) => obj.productid == id);
    let onCart = cart.find((obj) => obj.productid == id);

    let objIndex = null;
    let baseUnit = "Singles";

    if (onCart != null) {
      let tempArr = [...cart];
      objIndex = tempArr.findIndex((obj) => obj.productid == id);

      if (addedItem.salemode != "Singles") {

        if (unit == "Gram" || unit == "Mls") {
          //Change to kgs or litres
          qty = (parseFloat(qty) / 1000).toFixed(2);

        } else if (unit == "Centimeter") {
          //Change to kgs or litres
          qty = (parseFloat(qty) / 100).toFixed(2);

        }
      }

      tempArr[objIndex].qty = parseFloat(qty) + parseFloat(tempArr[objIndex].qty);
      const nowAddedTotal = parseFloat(addedItem.price) * parseFloat(qty);
      tempArr[objIndex].total = Number(
        parseFloat(nowAddedTotal) + parseFloat(tempArr[objIndex].total)
      ).toFixed(2);

      console.log("After update: ", tempArr[objIndex]);
      let netTotal = tempArr.reduce((acc, current) => acc + parseFloat(current.total), 0);
      netTotal = netTotal.toFixed(2);
      setCartTotal(netTotal);
      setCart([...tempArr]);
    } else {
      let obj = {};

      if (addedItem.salemode != "Singles") {
        if (unit == "Gram" || unit == "Mls") {
          //Change to kgs or litres
          qty = (parseFloat(qty) / 1000).toFixed(2);
        } else if (unit == "Centimeter") {
          //Change to kgs or litres
          qty = (parseFloat(qty) / 100).toFixed(2);

        }
      }

      obj = {
        productid: addedItem.productid,
        nam: addedItem.product,
        siunit: addedItem.salemode,
        qty: qty,
        price: Number(addedItem.price).toFixed(2),
        total: Number(parseFloat(addedItem.price) * parseFloat(qty)).toFixed(2),
      };
      const netTotal = Number(parseFloat(cartTotal) + parseFloat(obj.total)).toFixed(2);
      setCartTotal(netTotal);
      setCart([...cart, obj]);
    }
  }

  const renderProduct = (product, idx) => {
    return (
      <div style={{ flexDirection: "column", marginBottom: "30px", width: "100%" }} key={idx}>
        <div
          style={{
            flexDirection: "row",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            border: "1px solid #EA6C8238",
            padding: "10px",
            borderRadius: "10px",
          }}
        >
          <div style={{ width: "75%" }}>
            <div onClick={() => handleItemPress(product.productid)}>
              <b>
                {product.product}
              </b>
              <h6 style={{ fontFamily: "Open Sans" }}>
                ${product.price}
              </h6>

            </div>
            <div>
              {product.salemode == "Kgs" && <>
                <input id={`kg${product.productid}`} onChange={(e) => { setSiunits(prev => ({ ...prev, [product.productid]: e.target.value })) }}
                  type="radio" name={`kgs${product.productid}`} value="Kgs" />
                &nbsp;
                <label htmlFor={`kg${product.productid}`}>Kilograms</label>
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                <input id={`gr${product.productid}`} onChange={(e) => { setSiunits(prev => ({ ...prev, [product.productid]: e.target.value })) }}
                  type="radio" name={`kgs${product.productid}`} value="Gram" />
                &nbsp;
                <label htmlFor={`gr${product.productid}`}>Grams</label>
              </>}
              {product.salemode == "Litres" && <>
                <input id={`lt${product.productid}`} onChange={(e) => { setSiunits(prev => ({ ...prev, [product.productid]: e.target.value })) }}
                  type="radio" name={`litre${product.productid}`} value="Litre" />
                &nbsp;
                <label htmlFor={`lt${product.productid}`}>Litres</label>
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                <input id={`ms${product.productid}`} onChange={(e) => { setSiunits(prev => ({ ...prev, [product.productid]: e.target.value })) }}
                  type="radio" name={`litre${product.productid}`} value="Mls" />
                &nbsp;
                <label htmlFor={`ms${product.productid}`}>Millilitres</label>
              </>}
              {product.salemode == "Meters" && <>
                <input id={`mt${product.productid}`} onChange={(e) => { setSiunits(prev => ({ ...prev, [product.productid]: e.target.value })) }}
                  type="radio" name={`meter${product.productid}`} value="Meter" />
                &nbsp;
                <label htmlFor={`mt${product.productid}`}>Meters</label>
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                &nbsp;
                <input id={`cm${product.productid}`} onChange={(e) => { setSiunits(prev => ({ ...prev, [product.productid]: e.target.value })) }}
                  type="radio" name={`meter${product.productid}`} value="Centimeter" />
                &nbsp;
                <label htmlFor={`cm${product.productid}`}>Centimeters</label>
              </>}
            </div>
          </div>
          <div style={{ width: "25%" }}>


            <div><input
              placeholder={"Qty"}
              style={{
                width: "100%",
                borderWidth: 1,
                borderColor: "#EA6C82",
                borderRadius: 5,
                height: 50,
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                marginTop: "10px",
              }}
              value={quantities[product.productid] || ''}
              onChange={(text) => { setQuantities(prev => ({ ...prev, [product.productid]: text.target.value })) }}
            /></div>

          </div>

        </div>
      </div>
    );
  };

  const onSearchInput = (e) => {
    setsearchTerm(e.target.value);
  };

  const handleTenderedChange = (text, id) => {
    setCurrencies(prev =>
      prev.map(item =>
        item.id === id
          ? {
            ...item,
            tendered: text,
            usdValue: text && !isNaN(text)
              ? (parseFloat(text) / item.usdrate).toFixed(2)
              : ''
          }
          : item
      )
    );
  };

  const handleUsdValueChange = (text, id) => {
    setCurrencies(prev =>
      prev.map(item =>
        item.id === id
          ? {
            ...item,
            usdValue: text,
            tendered: text && !isNaN(text)
              ? (parseFloat(text) * item.usdrate).toFixed(2)
              : ''
          }
          : item
      )
    );
  };

  const handleCheckout = async () => {
    const items = Object.values(cart);
    if (!items.length) {
      toast.warn("Failed. Cart is empty", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      return;
    }
    const allRates = await getAllRecords(RATE_STORE);
    const transformedData = allRates.map(item => ({
      id: item.id,
      label: item.currency,
      usdrate: item.usdrate
    }));

    setCurrencies(transformedData);

    setPayIsOpen(true);
  };

  useEffect(() => {
    const getAsyncData = async () => {
      const sessionData = await JSON.parse(
        localStorage.getItem("userData")
      );

      setShopId(sessionData.shopid);
      setShopName(sessionData.shopname);

      setCashierId(sessionData.shopid);
      setCashierName(sessionData.fullname);
      const allPrdcts = await getAllRecords(PRODUCT_STORE);
      setProducts(allPrdcts);

      const allRates = await getAllRecords(RATE_STORE);

      const transformedData = allRates.map(item => ({
        id: item.id,
        label: item.currency,
        usdrate: item.usdrate
      }));

      setCurrencies(transformedData);

      const lastId = await getLastSalesId();
      let rec = parseInt(lastId) + 1;
      setReceiptnumber(rec);

      //setProducts(dummyProducts);

    };
    getAsyncData();
  }, []);

  const totalUsd = currencies.reduce((sum, item) => {
    const usd = parseFloat(item.usdValue);
    return sum + (isNaN(usd) ? 0 : usd);
  }, 0).toFixed(2);

  const saveSaleToDb = async () => {
    if (parseFloat(totalUsd) != parseFloat(cartTotal)) {
      toast.warn("Failed. Tendered amount is not equal to sale amount", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      return;
    }

    setPayIsOpen(false);

    var createdat = moment(new Date()).format("DD-MM-YYYY");
    var createtim = moment(new Date()).format("HH:mm:ss");

    let currency = "";
    let usdrate = "";
    let tendered = "";

    const filteredCurrencies = currencies.filter(item => 'tendered' in item);

    const saleObject = {
      synced: 0,
      nettotal: cartTotal,
      date: createdat,
      time: createtim,
      cashierid: cashierId,
      cartitems: cart,
      payments: filteredCurrencies
    }

    await addRecord(SALES_STORE, saleObject);
    setCart([]);
    setCartTotal(0.00);
    setQuantities({});
    setSiunits({});
    setReceiptnumber(parseInt(receiptnumber) + 1);

    toast.success("Sale Saved", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  }

  return (
    <>
      <Modal
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            marginTop: "50px",
          },
          content: {
            backgroundColor: "#ffffff",
            color: "#EA6C82",
            left: "5%",
            right: "5%",
            height: "650px",
          },
        }}
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        contentLabel="Example Modal"
      >
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "15px",
          }}
        >
          <h2 style={{ fontFamily: "Open Sans", fontSize: 20, color: '#547FF7', marginLeft: "10px", fontWeight: "bold" }}>Cart ${cartTotal}</h2>

          <button
            style={{
              backgroundColor: "#EA6C82",
              borderRadius: 5,
              border: "none",
              height: 40,
              fontFamily: "Open Sans",
              paddingInline: 14,
              fontSize: 14,
              color: "white",
              width: "110px",
            }}
            onClick={() => setModalIsOpen(false)}
          >
            Close Modal
          </button>
        </div>

        {/* <div
          style={{
            flexDirection: "row",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid #547FF750",
            padding: "10px"
          }}
        >
          <div style={{ width: "85%" }}>
            <b style={{ fontFamily: "Open Sans", fontSize: 16, color: '#547FF7' }}>
              Product Price By Unit
            </b>

          </div>

          <div style={{ width: "15%" }}>
            <b style={{ fontFamily: "Open Sans", fontSize: 16, color: '#547FF7', marginRight: '10px' }}>
              Remove
            </b>
          </div>
        </div> */}
        {cart.map((obj) => <>
          <div
            style={{
              flexDirection: "row",
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              borderBottom: "1px solid #EA6C8238",
              padding: "10px"
            }}
          >
            <div style={{ width: "85%" }}>
              <b style={{ color: '#000000' }}>
                {obj.nam}
              </b>
              <h6 style={{ fontFamily: "Open Sans", color: '#00000070' }}>
                ${obj.price} X {obj.qty}
              </h6>
              <b>
                ${obj.total}
              </b>
            </div>

            <div style={{ width: "15%" }}>
              <button
                style={{
                  backgroundColor: "#EA6C82",
                  borderRadius: 5,
                  border: "none",
                  height: 40,
                  fontFamily: "Open Sans",
                  paddingInline: 14,
                  fontSize: 14,
                  color: "white",
                  width: "100%",
                }}
                onClick={() => removeOnCart(obj.productid)}
              >
                X
              </button>
            </div>
          </div>
        </>


        )}


      </Modal>

      <Modal
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            marginTop: "50px",
          },
          content: {
            backgroundColor: "#ffffff",
            color: "#EA6C82",
            left: "5%",
            right: "5%",
            height: "650px",
            overFlow: "scroll"
          },
        }}
        isOpen={payIsOpen}
        onRequestClose={() => setPayIsOpen(false)}
        contentLabel="Example Modal"
      >
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "15px",
          }}
        >
          <div>
            <h2 style={{ fontFamily: "Open Sans", fontSize: 20, color: '#00000080', marginLeft: "10px", fontWeight: "bold" }}>Cart ${cartTotal}</h2>
            <h2 style={{ fontFamily: "Open Sans", fontSize: 20, color: '#547FF7', marginLeft: "10px", fontWeight: "bold" }}>Paid ${totalUsd}</h2>
          </div>

          <button
            style={{
              backgroundColor: "#EA6C82",
              borderRadius: 5,
              border: "none",
              height: 40,
              fontFamily: "Open Sans",
              paddingInline: 14,
              fontSize: 14,
              color: "white",
              width: "110px",
            }}
            onClick={() => setPayIsOpen(false)}
          >
            Close Modal
          </button>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)", // 2 items per row
            gap: "16px", // spacing between items
          }}
        >
          {currencies.map(item => (
            <div
              style={{
                flexDirection: "column",
                display: "flex",
                justifyContent: "space-between",
              }}

              key={item.id}
            >
              <p style={{ color: '#547FF7', marginTop: '10px' }}>
                {item.label} ({item.usdrate})
              </p>

              {/* Amount Tendered */}
              <input
                type="number"
                style={{
                  width: "100%",
                  borderWidth: 1,
                  borderColor: "#EA6C82",
                  borderRadius: 5,
                  height: 50,
                  fontFamily: "Open Sans",
                  fontSize: 14,
                  paddingInline: 10,
                }}
                placeholder={"Amount tendered"}
                value={item.tendered}
                onChange={e => handleTenderedChange(e.target.value, item.id)}
              />

              {/* USD Equivalent */}
              <input
                type="number"
                style={{
                  width: "100%",
                  borderWidth: 1,
                  borderColor: "#EA6C82",
                  borderRadius: 5,
                  height: 50,
                  fontFamily: "Open Sans",
                  fontSize: 14,
                  paddingInline: 10,
                  marginTop: "10px",
                }}
                placeholder="USD equivalent"
                keyboardType="numeric"
                value={item.usdValue}
                onChange={e => handleUsdValueChange(e.target.value, item.id)}
              />
            </div>
          ))}
        </div>

        <button
          style={{
            backgroundColor: "#EA6C82",
            borderRadius: 5,
            border: "none",
            height: 40,
            fontFamily: "Open Sans",
            paddingInline: 14,
            fontSize: 14,
            color: "white",
            width: "100%",
            marginTop: "10px"
          }}
          onClick={() => saveSaleToDb()}
        >
          Save Sale
        </button>
      </Modal>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ width: "70%", flexDirection: "column" }}>
          <p style={{ fontFamily: "Open Sans", fontSize: "14" }}>
            <b style={{ color: '#547FF7' }}>Shop</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{shopName}
          </p>

          <span style={{ fontFamily: "Open Sans", fontSize: "10" }}><b style={{ color: '#547FF7' }}>Cashier</b> {cashierName}</span>
          <br />
          <br />
          <span style={{ fontFamily: "Open Sans", fontSize: "10" }}><b style={{ color: '#547FF7' }}>Receipt</b> {receiptnumber}</span>
        </div>
        <div style={{ width: "25%", flexDirection: "column" }}>
          <button
            onClick={() => setModalIsOpen(true)}
            style={{
              width: "100%",
              backgroundColor: "#EA6C82",
              borderRadius: 5,
              border: "none",
              height: 50,
              fontFamily: "Open Sans",
              fontSize: 14,
              color: "white",
            }}
            className="form-control"
          >
            Items({cart.length})
          </button>
          <p style={{ color: '#547FF7', marginTop: '10px', alignSelf: 'center' }}>${cartTotal}</p>

        </div>

      </div>
      <div
        style={{
          flexDirection: "row",
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
          width: "100%"
        }}
      >
        <input
          placeholder={"Search products. . ."}
          style={{
            width: "70%",
            borderWidth: 1,
            borderColor: "#EA6C82",
            borderRadius: 5,
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            paddingInline: 10,
            marginTop: "10px",
          }}
          value={searchTerm}
          onChange={onSearchInput}
        />
        <button
          onClick={() => handleCheckout()}
          style={{
            width: "25%",
            backgroundColor: "#EA6C82",
            borderRadius: 5,
            border: "none",
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            color: "white",
            marginTop: "10px",
          }}
          className="form-control"
        >
          Charge
        </button>
      </div>


      <FlatList
        list={products}
        renderItem={renderProduct}
        renderWhenEmpty={() => (
          <div>
            <p style={{ color: "gray", fontFamily: "Open Sans" }}>
              No items matching your search . . .
            </p>
          </div>
        )}
        sortBy={["productid", { key: "productid", descending: true }]}
        //   searchBy={["alias", "surname"]}
        //   searchTerm={searchTerm}
        search={{
          by: ["product", "price"],
          term: searchTerm,
          caseInsensitive: true,
        }}
        style={{ marginBottom: "700px" }}
      />

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
};

export default Home;
